import React, { createContext, useRef, useContext, useState } from 'react'
import { UseFloorProvider } from './floorProvider'

interface IMap {
  current: any | null
}

interface IMapParams {
  selectedNeighborhoodId: null | string
  selectedDepartmentId: null | string
}

const MapContext = createContext<React.RefObject<IMap>>({ current: null })
const MapParamsContext = createContext<
  IMapParams & { setParams: React.Dispatch<React.SetStateAction<IMapParams>> | null }
>({
  selectedNeighborhoodId: null,
  selectedDepartmentId: null,
  setParams: null,
})

type Props = {
  children: React.ReactNode
}

const MapContextProvider: React.FC<React.PropsWithChildren<Props>> = ({ children }) => {
  const [params, setParams] = useState<IMapParams>({
    selectedNeighborhoodId: null,
    selectedDepartmentId: null,
  })
  const ref = useRef<IMap>(null)

  return (
    <MapContext.Provider value={ref}>
      <MapParamsContext.Provider
        value={{
          setParams,
          ...params,
        }}>
        <UseFloorProvider>{children}</UseFloorProvider>
      </MapParamsContext.Provider>
    </MapContext.Provider>
  )
}

function useMapInit(): React.RefObject<IMap> {
  const context = useContext(MapContext)
  if (context === undefined) {
    throw new Error('useMapInit must be used within a ContextProvider')
  }
  return context
}

function useAdminMapParams() {
  const context = useContext(MapParamsContext)
  if (context === undefined) {
    throw new Error('useMapInit must be used within a ContextProvider')
  }
  return context
}

export { MapContextProvider, useMapInit, useAdminMapParams }
